import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var RetrieveProductKeySellingPointsQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query RetrieveProductKeySellingPointsQuery($navigationId: ID!) {\n    keySellingPoint(id: $navigationId) {\n      navigationId\n      items\n    }\n  }\n"])));
export default RetrieveProductKeySellingPointsQuery;